var _require = require('../consts'),
  GEOCOMPLY_PLC_VERSION = _require.GEOCOMPLY_PLC_VERSION;
var sharedConfig = {
  czr: {
    NAME: "Caesars Sportsbook",
    NAMES: {
      android: "Caesars Sportsbook",
      ios: "Caesars&#8201;Sportsbook",
      base: "Caesars",
      initials: "CZR SBK"
    },
    NAME_AND_REGION: true,
    DARK_MODE: false,
    THEME: "czr",
    BRAND_THEME_CSS: "czr",
    DEEP_LINK: {
      prod: "williamhillus",
      default: "caesarssportsbook"
    },
    ADD_SUFFIX: true,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: true,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: false,
    LOGO_PATH: "./images/czr_logo.svg",
    BUNDLE_IDS: {
      local: "us.williamhill.nj.sports.beta.enterprise",
      dev: "us.williamhill.nj.sports.gpd",
      test: "us.williamhill.nj.sports.gpt",
      cert: "us.williamhill.nj.sports.enterprise",
      internalprod: "us.williamhill.nj.sports.internalprod",
      prod: "com.williamhill.us.nj.sports"
    },
    SHOW_FEEDBACK: true,
    GAME_RESPONSIBLY_LINK: "http://caesars.com/sportsbook-and-casino/on/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl",
    CASINO_ICON_NAME: "",
    ANDROID_ICON_COLOR: "#876E3F",
    OUTAGE_PAGE: "czr-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "http://play.google.com/store/apps/details?id=com.williamhill.us.nj.sports",
      ios: "http://apps.apple.com/us/app/caesars-sportsbook/id1413099571?action=write-review"
    },
    LOCAL_DEV_INITIAL_STATE: "nj",
    EXCLUDE_STATUS_BAR_STYLE: false,
    API_BRAND: "czr",
    X_PLATFORM: {
      ios: "cordova-",
      android: "cordova-",
      desktop: "cordova-"
    },
    X_APP_BRANDING: "Liberty",
    PLAYER_LOCATION_CHECK_LINK: {
      co: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=Ihkfgaen8a"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=Ihkfgaen8a")
      },
      ia: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=O5FWnQSXGx"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=O5FWnQSXGx")
      },
      il: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=zegKGBLdlh"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=zegKGBLdlh")
      },
      in: {
        windows: "https://ums.geocomply.com/installer/url?id=FK8dE6JWUy&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=FK8dE6JWUy&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      mi: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=cnBtGnCTmX"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=cnBtGnCTmX")
      },
      nc: {
        windows: "https://ums.geocomply.com/installer/url?id=taY8g0jEQy&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=taY8g0jEQy&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      nj: {
        windows: "https://ums.geocomply.com/installer/url?id=2eovSGXNs1&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=2eovSGXNs1&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      tn: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=DMYAA3atX8"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=DMYAA3atX8")
      },
      wv: {
        windows: "https://ums.geocomply.com/installer/url?id=QbyEV6Bq17&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=QbyEV6Bq17&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      va: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=54uhzVBkHJ"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=54uhzVBkHJ")
      },
      az: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=NTtXTwCToo"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=NTtXTwCToo")
      },
      ct: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=kSSieu8vRv"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=kSSieu8vRv")
      },
      la: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=s4gkKER62G"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=s4gkKER62G")
      },
      nv: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=f5J0ZJ7kUv"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=f5J0ZJ7kUv")
      },
      ny: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=kxW7uBvCLV"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=kxW7uBvCLV")
      },
      on: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=pKHljU1lxy"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=pKHljU1lxy")
      },
      pa: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=QDy9DK5Q3T"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=QDy9DK5Q3T")
      },
      wy: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=mee2Z0Xg2j"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=mee2Z0Xg2J")
      },
      dc: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=RNdscXSCZO"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=RNdscXSCZO")
      },
      ks: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=v6jQmUGTPz"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=v6jQmUGTPz")
      },
      ky: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=qX6EJYeDrA"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=qX6EJYeDrA")
      },
      oh: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=xMKGQSmrNy"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=xMKGQSmrNy")
      },
      md: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=14DkM0sxKy"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=14DkM0sxKy")
      },
      ma: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=Wt1QiLKZ7V"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=Wt1QiLKZ7V")
      },
      pr: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=HxiSYrNgd9"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=HxiSYrNgd9")
      },
      me: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=x7n6PapCk8"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=x7n6PapCk8")
      },
      'wa-ms': {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=MFPvYS1WsG"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=MFPvYS1WsG")
      },
      ms: {
        windows: "",
        mac: ""
      }
    }
  },
  'czr-pr': {
    NAME: "Caesars Sportsbook Puerto Rico",
    NAMES: {
      android: "Caesars Sportsbook Puerto Rico",
      ios: "Caesars&#8201;Sportsbook&#8201;Puerto&#8201;Rico",
      base: "Caesars",
      initials: "CZR PR"
    },
    NAME_AND_REGION: false,
    DARK_MODE: false,
    THEME: "czr",
    BRAND_THEME_CSS: "czr",
    DEEP_LINK: {
      prod: "caesarssportsbookpr",
      default: "caesarssportsbookpr"
    },
    ADD_SUFFIX: true,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: false,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: false,
    LOGO_PATH: "./images/czr_logo.svg",
    BUNDLE_IDS: {
      local: "com.caesars.czr.pr.local",
      dev: "com.caesars.czr.pr.dev",
      test: "com.caesars.czr.pr.test",
      cert: "com.caesars.czr.pr.cert",
      internalprod: "com.caesars.czr.pr.internalprod",
      prod: "com.caesarsdigital.sportsbook.pr"
    },
    SHOW_FEEDBACK: false,
    GAME_RESPONSIBLY_LINK: "http://caesars.com/sportsbook-and-casino/on/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl",
    CASINO_ICON_NAME: "",
    ANDROID_ICON_COLOR: "#876E3F",
    OUTAGE_PAGE: "czr-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "",
      ios: "http://apps.apple.com/us/app/caesars-sportsbook/id1413099571?action=write-review"
    },
    LOCAL_DEV_INITIAL_STATE: "pr",
    EXCLUDE_STATUS_BAR_STYLE: false,
    API_BRAND: "czr",
    X_PLATFORM: {
      ios: "cordova-",
      android: "cordova-",
      desktop: "cordova-"
    },
    X_APP_BRANDING: "Liberty",
    PLAYER_LOCATION_CHECK_LINK: {
      pr: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=HxiSYrNgd9"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=HxiSYrNgd9")
      }
    }
  },
  'czr-wa-ms': {
    NAME: "Caesars Sportsbook Muckleshoot",
    NAMES: {
      android: "Caesars Sportsbook Muckleshoot",
      ios: "Caesars&#8201;Sportsbook&#8201;Muckleshoot",
      base: "Caesars",
      initials: "CZR WA-MS"
    },
    NAME_AND_REGION: false,
    DARK_MODE: false,
    THEME: "czr",
    BRAND_THEME_CSS: "czr",
    DEEP_LINK: {
      prod: "caesarsmuckleshoot",
      default: "caesarsmuckleshoot"
    },
    ADD_SUFFIX: true,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: false,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: false,
    LOGO_PATH: "./images/czr_logo.svg",
    BUNDLE_IDS: {
      local: "com.caesars.czr.wa.ms.local",
      dev: "com.caesars.czr.wa.ms.dev",
      test: "com.caesars.czr.wa.ms.test",
      cert: "com.caesars.czr.wa.ms.cert",
      internalprod: "com.caesars.czr.wa.ms.internalprod",
      prod: "com.caesarsdigital.sportsbook.wa.ms"
    },
    SHOW_FEEDBACK: false,
    GAME_RESPONSIBLY_LINK: "http://caesars.com/sportsbook-and-casino/on/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl",
    CASINO_ICON_NAME: "",
    ANDROID_ICON_COLOR: "#876E3F",
    OUTAGE_PAGE: "czr-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "",
      ios: "http://apps.apple.com/us/app/caesars-sportsbook-muckleshoot/id6463739626?action=write-review"
    },
    LOCAL_DEV_INITIAL_STATE: "wa-ms",
    EXCLUDE_STATUS_BAR_STYLE: false,
    API_BRAND: "czr",
    X_PLATFORM: {
      ios: "cordova-",
      android: "cordova-",
      desktop: "cordova-"
    },
    X_APP_BRANDING: "Liberty",
    PLAYER_LOCATION_CHECK_LINK: {
      'wa-ms': {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=MFPvYS1WsG"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=MFPvYS1WsG")
      }
    }
  },
  'czr-ms': {
    NAME: "Caesars Sportsbook Mississippi",
    NAMES: {
      android: "Caesars Sportsbook Mississippi",
      ios: "Caesars&#8201;Sportsbook&#8201;Mississippi",
      base: "Caesars",
      initials: "CZR MS"
    },
    NAME_AND_REGION: false,
    DARK_MODE: false,
    THEME: "czr",
    BRAND_THEME_CSS: "czr",
    DEEP_LINK: {
      prod: "caesarssportsbook",
      default: "caesarssportsbook"
    },
    ADD_SUFFIX: true,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: false,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: false,
    LOGO_PATH: "./images/czr_logo.svg",
    BUNDLE_IDS: {
      local: "com.caesars.czr.ms.local",
      dev: "com.caesars.czr.ms.dev",
      test: "com.caesars.czr.ms.test",
      cert: "com.caesars.czr.ms.cert",
      internalprod: "com.caesars.czr.ms.internalprod",
      prod: "com.caesarsdigital.sportsbook.ms"
    },
    SHOW_FEEDBACK: false,
    GAME_RESPONSIBLY_LINK: "http://caesars.com/sportsbook-and-casino/on/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl",
    CASINO_ICON_NAME: "",
    ANDROID_ICON_COLOR: "#876E3F",
    OUTAGE_PAGE: "czr-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "",
      ios: "http://apps.apple.com/us/app/caesars-sportsbook/id1413099571?action=write-review"
    },
    LOCAL_DEV_INITIAL_STATE: "ms",
    EXCLUDE_STATUS_BAR_STYLE: false,
    API_BRAND: "czr",
    X_PLATFORM: {
      ios: "cordova-",
      android: "cordova-",
      desktop: "cordova-"
    },
    X_APP_BRANDING: "Liberty",
    PLAYER_LOCATION_CHECK_LINK: {
      ms: {
        windows: "",
        mac: ""
      }
    }
  },
  wh: {
    NAME: "William Hill Sportsbook",
    NAMES: {
      android: "William Hill",
      ios: "William&#8201;Hill",
      base: "William Hill",
      initials: "WH NV"
    },
    NAME_AND_REGION: true,
    DARK_MODE: false,
    THEME: "wh",
    BRAND_THEME_CSS: "wh",
    DEEP_LINK: {
      prod: "williamhillnv",
      default: "williamhillnv"
    },
    ADD_SUFFIX: true,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: false,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: true,
    LOGO_PATH: "./images/wh_logo.svg",
    BUNDLE_IDS: {
      local: "us.williamhill.wh.sports.local",
      dev: "us.williamhill.wh.sports.dev",
      test: "us.williamhill.wh.sports.test",
      cert: "us.williamhill.wh.sports.cert",
      internalprod: "us.williamhill.wh.sports.internalprod",
      prod: "com.awi.whrp"
    },
    SHOW_FEEDBACK: false,
    GAME_RESPONSIBLY_LINK: "http://caesars.com/sportsbook-and-casino/on/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl",
    CASINO_ICON_NAME: "",
    ANDROID_ICON_COLOR: "#001534",
    OUTAGE_PAGE: "wh-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "http://play.google.com/store/apps/details?id=com.awi.whrp",
      ios: "http://apps.apple.com/us/app/william-hill-nevada/id1021616457?action=write-review"
    },
    LOCAL_DEV_INITIAL_STATE: "nv",
    EXCLUDE_STATUS_BAR_STYLE: true,
    API_BRAND: "wh",
    X_PLATFORM: {
      ios: "cordova-",
      android: "cordova-",
      desktop: "cordova-"
    },
    X_APP_BRANDING: "Liberty",
    PLAYER_LOCATION_CHECK_LINK: {
      nv: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=lqRe5lBZhU"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=lqRe5lBZhU")
      }
    }
  },
  'czr-casino': {
    NAME: "Caesars Palace Online Casino",
    NAMES: {
      android: "Caesars Casino",
      ios: "Caesars&#8201;Casino",
      base: "Caesars",
      initials: "CPO"
    },
    NAME_AND_REGION: true,
    DARK_MODE: false,
    THEME: "czr-palace",
    BRAND_THEME_CSS: "czr",
    DEEP_LINK: {
      prod: "caesarspalaceonline",
      default: "caesarspalaceonline"
    },
    ADD_SUFFIX: true,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: false,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: true,
    LOGO_PATH: "./images/czr_logo.svg",
    BUNDLE_IDS: {
      local: "com.caesars.czr.casino.local",
      dev: "com.caesars.czr.casino.dev",
      test: "com.caesars.czr.casino.test",
      cert: "com.caesars.czr.casino.cert",
      internalprod: "com.caesars.czr.casino.internalprod",
      prod: "com.caesarsdigital.igaming.caesarspalaceonline"
    },
    SHOW_FEEDBACK: true,
    GAME_RESPONSIBLY_LINK: "http://caesarspalaceonline.com/on/support/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl-bold",
    CASINO_ICON_NAME: "brand_czr-profile-laurel",
    ANDROID_ICON_COLOR: "#850024",
    OUTAGE_PAGE: "czr-palace-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "http://play.google.com/store/apps/details?id=com.caesarsdigital.igaming.caesarspalaceonline",
      ios: ""
    },
    LOCAL_DEV_INITIAL_STATE: "nj",
    EXCLUDE_STATUS_BAR_STYLE: true,
    API_BRAND: "czr",
    X_PLATFORM: {
      ios: "cordova-",
      android: "casino-palace-",
      desktop: "casino-palace-"
    },
    X_APP_BRANDING: "Caesars Palace Online",
    PLAYER_LOCATION_CHECK_LINK: {
      nj: {
        windows: "https://ums.geocomply.com/installer/url?id=2eovSGXNs1&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=2eovSGXNs1&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      mi: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=cnBtGnCTmX"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=cnBtGnCTmX")
      },
      wv: {
        windows: "https://ums.geocomply.com/installer/url?id=QbyEV6Bq17&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=QbyEV6Bq17&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      on: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=pKHljU1lxy"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=pKHljU1lxy")
      },
      pa: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=QDy9DK5Q3T"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=QDy9DK5Q3T")
      }
    }
  },
  horseshoe: {
    NAME: "Horseshoe Online Casino",
    NAMES: {
      android: "Horseshoe Casino",
      ios: "Horseshoe&#8201;Casino",
      base: "Horseshoe",
      initials: "HORSESHOE"
    },
    NAME_AND_REGION: true,
    DARK_MODE: true,
    THEME: "horseshoe",
    BRAND_THEME_CSS: "czr",
    DEEP_LINK: {
      prod: "horseshoeonline",
      default: "horseshoeonline"
    },
    ADD_SUFFIX: true,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: false,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: true,
    LOGO_PATH: "./images/czr_logo.svg",
    BUNDLE_IDS: {
      local: "com.caesars.czr.horseshoe.local",
      dev: "com.caesars.czr.horseshoe.dev",
      test: "com.caesars.czr.horseshoe.test",
      cert: "com.caesars.czr.horseshoe.cert",
      internalprod: "com.caesars.czr.horseshoe.internalprod",
      prod: "com.caesarsdigital.igaming.horseshoeonlinecasino"
    },
    SHOW_FEEDBACK: true,
    GAME_RESPONSIBLY_LINK: "http://caesars.com/sportsbook-and-casino/on/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl",
    CASINO_ICON_NAME: "brand_horseshoe-horseshoe",
    ANDROID_ICON_COLOR: "#263456",
    OUTAGE_PAGE: "czr-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "http://play.google.com/store/apps/details?id=com.caesarsdigital.igaming.horseshoeonlinecasino",
      ios: ""
    },
    LOCAL_DEV_INITIAL_STATE: "mi",
    EXCLUDE_STATUS_BAR_STYLE: true,
    API_BRAND: "czr",
    X_PLATFORM: {
      ios: "cordova-",
      android: "casino-horseshoe-",
      desktop: "casino-horseshoe-"
    },
    X_APP_BRANDING: "Horseshoe",
    PLAYER_LOCATION_CHECK_LINK: {
      nj: {
        windows: "https://ums.geocomply.com/installer/url?id=2eovSGXNs1&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=2eovSGXNs1&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      mi: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=cnBtGnCTmX"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=cnBtGnCTmX")
      },
      wv: {
        windows: "https://ums.geocomply.com/installer/url?id=QbyEV6Bq17&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=QbyEV6Bq17&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      on: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=pKHljU1lxy"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=pKHljU1lxy")
      },
      pa: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=QDy9DK5Q3T"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=QDy9DK5Q3T")
      }
    }
  },
  nft: {
    NAME: "Non Functional Testing",
    NAMES: {
      android: "Caesars Sportsbook NFT",
      ios: "Caesars&#8201;Sportsbook&#8201;NFT",
      base: "Caesars",
      initials: "CZR NFT"
    },
    NAME_AND_REGION: true,
    DARK_MODE: false,
    THEME: "czr",
    BRAND_THEME_CSS: "czr",
    DEEP_LINK: {
      prod: "williamhillus",
      default: "williamhillus"
    },
    ADD_SUFFIX: false,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: false,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: false,
    LOGO_PATH: "./images/czr_logo.svg",
    BUNDLE_IDS: {
      local: "com.caesars.czr.nft.local",
      dev: "com.caesars.czr.nft.dev",
      test: "com.caesars.czr.nft.test",
      cert: "com.caesars.czr.nft.cert",
      internalprod: "com.caesars.czr.nft.internalprod",
      prod: "com.caesarsdigital.sportsbook.nft"
    },
    SHOW_FEEDBACK: false,
    GAME_RESPONSIBLY_LINK: "http://caesars.com/sportsbook-and-casino/on/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl",
    CASINO_ICON_NAME: "",
    ANDROID_ICON_COLOR: "#876E3F",
    OUTAGE_PAGE: "czr-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "",
      ios: ""
    },
    LOCAL_DEV_INITIAL_STATE: "nf1",
    EXCLUDE_STATUS_BAR_STYLE: false,
    API_BRAND: "nft",
    X_PLATFORM: {
      ios: "cordova-",
      android: "cordova-",
      desktop: "cordova-"
    },
    X_APP_BRANDING: "Liberty",
    PLAYER_LOCATION_CHECK_LINK: {}
  },
  'czr-uat': {
    NAME: "Caesars Sportsbook UAT",
    NAMES: {
      android: "Caesars Sportsbook UAT",
      ios: "Caesars&#8201;Sportsbook&#8201;UAT",
      base: "Caesars",
      initials: "CZR UAT"
    },
    NAME_AND_REGION: true,
    DARK_MODE: false,
    THEME: "czr",
    BRAND_THEME_CSS: "czr",
    DEEP_LINK: {
      prod: "williamhillus",
      default: "williamhillus"
    },
    ADD_SUFFIX: false,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: false,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: false,
    LOGO_PATH: "./images/czr_logo.svg",
    BUNDLE_IDS: {
      local: "com.caesars.czr.uat.local",
      dev: "com.caesars.czr.uat.dev",
      test: "com.caesars.czr.uat.test",
      cert: "com.caesars.czr.uat.cert",
      internalprod: "com.caesars.czr.uat.internalprod",
      prod: "com.caesarsdigital.sportsbook.uat"
    },
    SHOW_FEEDBACK: false,
    GAME_RESPONSIBLY_LINK: "http://caesars.com/sportsbook-and-casino/on/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl",
    CASINO_ICON_NAME: "",
    ANDROID_ICON_COLOR: "#876E3F",
    OUTAGE_PAGE: "czr-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "",
      ios: ""
    },
    LOCAL_DEV_INITIAL_STATE: "wv",
    EXCLUDE_STATUS_BAR_STYLE: false,
    API_BRAND: "czr-uat",
    X_PLATFORM: {
      ios: "cordova-",
      android: "cordova-",
      desktop: "cordova-"
    },
    X_APP_BRANDING: "Liberty",
    PLAYER_LOCATION_CHECK_LINK: {}
  },
  'czr-casino-uat': {
    NAME: "Caesars Palace Online Casino UAT",
    NAMES: {
      android: "Caesars Casino UAT",
      ios: "Caesars&#8201;Casino&#8201;UAT",
      base: "Caesars",
      initials: "CPO UAT"
    },
    NAME_AND_REGION: true,
    DARK_MODE: false,
    THEME: "czr-palace",
    BRAND_THEME_CSS: "czr",
    DEEP_LINK: {
      prod: "caesarspalaceonline",
      default: "caesarspalaceonline"
    },
    ADD_SUFFIX: true,
    REQUIRES_WH_BACKWARDS_COMPATIBILITY: false,
    UPDATE_ANDROID_PRELOADING_SCREEN_PATH: true,
    LOGO_PATH: "./images/czr_logo.svg",
    BUNDLE_IDS: {
      local: "com.caesars.czr.casino.uat.local",
      dev: "com.caesars.czr.casino.uat.dev",
      test: "com.caesars.czr.casino.uat.test",
      cert: "com.caesars.czr.casino.uat.cert",
      internalprod: "com.caesars.czr.casino.uat.internalprod",
      prod: "com.caesarsdigital.igaming.caesarspalaceonline.uat"
    },
    SHOW_FEEDBACK: true,
    GAME_RESPONSIBLY_LINK: "http://caesarspalaceonline.com/on/support/responsible-gaming/",
    ALMOST_THERE_HEADER_SIZE: "xl-bold",
    CASINO_ICON_NAME: "brand_czr-profile-laurel",
    ANDROID_ICON_COLOR: "#850024",
    OUTAGE_PAGE: "czr-palace-outage-splash.html",
    APP_STORE_REVIEW_LINK: {
      android: "",
      ios: ""
    },
    LOCAL_DEV_INITIAL_STATE: "wv",
    EXCLUDE_STATUS_BAR_STYLE: true,
    API_BRAND: "czr-uat",
    X_PLATFORM: {
      ios: "cordova-",
      android: "casino-palace-",
      desktop: "casino-palace-"
    },
    X_APP_BRANDING: "Caesars Palace Online",
    PLAYER_LOCATION_CHECK_LINK: {
      nj: {
        windows: "https://ums.geocomply.com/installer/url?id=2eovSGXNs1&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=2eovSGXNs1&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      mi: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=cnBtGnCTmX"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=cnBtGnCTmX")
      },
      wv: {
        windows: "https://ums.geocomply.com/installer/url?id=QbyEV6Bq17&os=win&version=".concat(GEOCOMPLY_PLC_VERSION),
        mac: "https://ums.geocomply.com/installer/url?id=QbyEV6Bq17&os=mac&version=".concat(GEOCOMPLY_PLC_VERSION)
      },
      on: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=pKHljU1lxy"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=pKHljU1lxy")
      },
      pa: {
        windows: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=win&id=QDy9DK5Q3T"),
        mac: "https://ums.geocomply.com/installer/url/?version=".concat(GEOCOMPLY_PLC_VERSION, "&os=mac&id=QDy9DK5Q3T")
      }
    }
  }
};
module.exports = sharedConfig;